import React, { useState } from 'react'
import { Text } from '@mantine/core'
import LotteryRulesModal from './components/LotteryRulesModal'

const LotteryRules: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleClick = () => {
    setModalOpen(true)
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          right: 0,
          top: '16%',
          transform: 'translateY(-50%)',
          background: 'linear-gradient(180deg, #FEAD21 0%, #FE5D31 100%)',
          borderRadius: '12px 0px 0px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100,
          cursor: 'pointer',
          padding: '8px 12px',
          userSelect: 'none',
          boxShadow: '0 3px 12px rgba(254, 173, 33, 0.4)',
        }}
        onClick={handleClick}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <Text
            style={{
              color: 'white',
              fontSize: 13,
              fontWeight: 600,
              lineHeight: '16px',
              textAlign: 'left',
              fontStyle: 'normal',
              textTransform: 'none',
              textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
              letterSpacing: '0.3px',
            }}
          >
            活动规则
          </Text>
        </div>

        <div
          style={{
            marginLeft: 8,
            color: 'white',
            fontSize: 12,
            opacity: 0.8,
            lineHeight: 1,
          }}
        >
          ▶
        </div>
      </div>

      <LotteryRulesModal opened={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  )
}

export default LotteryRules
